import "./Tag.scss";
import { FC } from "react";

type TagSize = "sm" | "md" | "lg";

interface ITag {
    name: string;
    color: string;
    textColor?: string;
    close?: boolean;
    onClose?: () => void;
    size?: TagSize;
}

const hexToRgba = (hex: string, alpha: number) => {
    const cleaned = hex.replace("#", "").trim();
    const full =
        cleaned.length === 3
            ? cleaned
                .split("")
                .map(ch => ch + ch)
                .join("")
            : cleaned;

    if (!/^[0-9a-fA-F]{6}$/.test(full)) return `rgba(0, 0, 0, ${alpha})`;

    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const Tag: FC<ITag> = ({
                           name,
                           color,
                           textColor,
                           close = false,
                           onClose = () => {},
                           size = "md",
                       }) => {
    const tagClasses = ["tag", `tag--${size}`, close ? "tag--has-close" : ""]
        .filter(Boolean)
        .join(" ");

    const effectiveTextColor = textColor ?? color;

    return (
        <span
            className={tagClasses}
            style={{
                backgroundColor: hexToRgba(color, 0.13),
                color: effectiveTextColor,
            }}
        >
      {name}
            {close && (
                <div className="tag__close" onClick={onClose}>
                    x
                </div>
            )}
    </span>
    );
};

export default Tag;
